<div class="chgPwdWrap shadowBox">
  <div class="formContainer">
    <div class="titleRow pd">
      <h2 class="subTitle01-1">Change your password</h2>
    </div>
    <p class="invalidInput serverErr" [ngClass]="(showError==false ) ? 'hide':''" ><span class="bi bi-exclamation-diamond"></span>{{ERRSuccMsg}}</p>
    <p class="invalidInput successToast " [ngClass]="(showSuccess==false ) ? 'hide':''"><span class="bi bi-check-circle"></span>{{ERRSuccMsg}}</p>
    <div class="pd">
      <!-- <div class="formRow error">
        <div class="inputBox">
          <input id="currentpassword" type="text" placeholder=" " />
          <label for="currentpassword">Curent Password <span class="required">*</span></label>
        </div>
        <div class="errorMsg">Validation Error message</div>
      </div> -->
      <div class="formRow hr">
        <div class="inputBox withIcon">
          <input id="newpassword" type="text" placeholder=" " [(ngModel)]="newPassword" (input)="isShowCPwdAnnnew3 = true" (blur)="isShowCPwdAnnnew3 = false"
          [type]="showPassword ? 'password' : 'text'" (focus)="clearErrSuccMsg()" maxlength="50"/>
          <label for="newpassword">New Password <span class="required">*</span></label>
          <span><button class="showPass rt" (click)="showPasswordE()">
            <span class="bi icon-l primaryClrIcon" [class]="showPassword ? 'bi-eye' : 'bi-eye-slash'"></span>
          </button></span>
          <div class="errorMsg">Validation Error message</div><span class="bi bi-info-circle icon-l primaryClrIcon"></span>
          <div class="pwdtooltiptext shadowBox">
            <p class="pwdMust">Password must have at least:</p>
            <ul>
              <li><span class="bi bi-circle-fill"></span>8 Characters</li>
              <li><span class="bi bi-circle-fill"></span>1 Special Character</li>
              <li><span class="bi bi-circle-fill"></span>1 Capital Letter</li>
              <li><span class="bi bi-circle-fill"></span>1 Number</li>
            </ul>
          </div>
        </div>
        <div class="errorMsg">Validation Error message</div>
      </div>
      <div class="formRow">
        <div class="inputBox withIcon">
          <input id="confirmnewpassword" type="text" placeholder=" "  [(ngModel)]="confirmPassword" (input)="isShowCPwdAnnconf3 = true" (blur)="isShowCPwdAnnconf3 = false"
          [type]="showPassword ? 'password' : 'text'" (focus)="clearErrSuccMsg()" maxlength="50" />
          <label for="confirmnewpassword">Confirm New Password <span class="required">*</span></label>
          <span><button class="showPass rt" (click)="showPasswordE()">
            <span class="bi icon-l primaryClrIcon" [class]="showPassword ? 'bi-eye' : 'bi-eye-slash'"></span>
          </button></span>

          <span
            class="bi bi-info-circle icon-l primaryClrIcon"></span>
          <div class="pwdtooltiptext shadowBox">
            <p class="pwdMust">Password must have at least:</p>
            <ul>
              <li><span class="bi bi-circle-fill"></span>8 Characters</li>
              <li><span class="bi bi-circle-fill"></span>1 Special Character</li>
              <li><span class="bi bi-circle-fill"></span>1 Capital Letter</li>
              <li><span class="bi bi-circle-fill"></span>1 Number</li>
            </ul>
          </div>
        </div>
        <div class="errorMsg">Validation Error message</div>
      </div>
      <div class="formRow">
        <div class="buttonSec">
          <button type="submit"  (click)="submitPassword()">Update</button>
        </div>
      </div>
    </div>
  </div>
</div>
